// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__QQtoh","colCheckbox":"styles_colCheckbox__CIAB4"};